import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A3C7C111-C3C4-456D-B631-649D9D99E714
 * name calendar-import-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-import-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarImportOutlineIcon = createSvgIcon(<><path d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H9V19H5V9H19V19H15V21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M5 7V5H19V7H5M12 12L8 16H11V22H13V16H16L12 12Z" /></>, 'CalendarImportOutlineIcon');
export default CalendarImportOutlineIcon